
import Workout from "./Workout";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import {
    getWorkoutPublic,
    createWorkoutCopy,
  } from "../../redux/slices/workoutSlice";

const WorkoutPublicContainer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { token } = useSelector((state) => state.authSlice);
  const { user } = useSelector((state) => state.profileSlice);
  const { pub_workout_id } = useParams();
  const { workout, workout_id } = useSelector((state) => state.workoutSlice);
  const [workoutActivities, setWorkoutActivities] = useState([]);
  const [workoutStats, setWorkoutStats] = useState(null);

  const [loginRegisterOpen, setLoginRegisterOpen] = useState(false);
  const [bottomNavigationState, setBottomNavigationState] = useState("view");

  const [selectedIdForEdit, setSelectedIdForEdit] = useState(null);
  const [activityForEdit, setActivityForEdit] = useState(null);

  const handleOpenLoginRegister = () => setLoginRegisterOpen(true);
  const handleCloseLoginRegister = () => setLoginRegisterOpen(false);

  useEffect(() => {
    if (pub_workout_id) {
      if (token && user) {
        dispatch(
          createWorkoutCopy({
            token: token,
            workout_id: pub_workout_id,
            user_id: user.email,
          })
        );
      }
      if (!token) {
        dispatch(
          getWorkoutPublic({
            token: token,
            workout_id: pub_workout_id,
          })
        );
      }
    }
  }, [pub_workout_id, user, dispatch, token]);

  // probably want to just add a add workout template or start your own menu item
  useEffect(() => {
    if (pub_workout_id && workout_id) {
      if (pub_workout_id !== workout_id) {
        navigate(`/workout/${workout_id}`);
      }
    }
  }, [pub_workout_id, workout_id, navigate]);

  useEffect(() => {
    if (workout) {
      const allActivitiesReset = workout.allWorkoutActivities.map(
        (activity) => {
          return {
            ...activity,
            completed: false,
          };
        }
      );
      setWorkoutActivities(allActivitiesReset);
      setWorkoutStats(workout.stats);
    }
  }, [workout]);

  const handleUserActionWithNoToken = () => {
    handleOpenLoginRegister();
  };

  const handleCheckBoxChange = async (activity, completed, index) => {
    let copy = [...workoutActivities];
    copy[index] = { ...copy[index], completed };
    setWorkoutActivities(copy);
  };

  const handleCopyWorkout = () => {
    const parsedStrings = workoutActivities.reduce((workout, activity) => {
      return `${workout}${activity.parsed}\n`;
    }, "");
    navigator.clipboard
      .writeText(parsedStrings)
      .then(() => {
        console.log("Workout copied to clipboard!");
        alert("Workout copied to clipboard!");
      })
      .catch((error) => {
        console.error("Failed to copy text to clipboard:", error);
      });
  };

  const handleBottomNavigationChange = (value) => {
    setBottomNavigationState(value);
    if (selectedIdForEdit) {
      setSelectedIdForEdit(null);
      setActivityForEdit(null);
    }
  };

  const handleEditActivity = async (activity) => {
    // await axios.post(
    //   `/api/exercise/editActivity`,
    //   {
    //     workout_id,
    //     activity,
    //   },
    //   {
    //     headers: {
    //       "Content-Type": "application/json",
    //       Authorization: `Bearer ${token}`,
    //     },
    //   }
    // );
    setActivityForEdit(null);
    setSelectedIdForEdit(null);
    if (activity.type === "exercise") {
      const { data: exercise } = activity;
      const savedExercise = {
        type: "exercise",
        parsed: `${exercise.reps} X ${exercise.sets} ${exercise.name} @ ${
          exercise.weight
        } ${exercise.exerciseUnit === 0 ? "lbs" : "kgs"}`,
        data: {
          ...exercise,
        },
      };
      const updatedActivities = workoutActivities.map((a) => {
        if (getActivityId(a) === exercise.exercise_id) {
          return savedExercise;
        } else {
          return a;
        }
      });
      setWorkoutActivities([...updatedActivities]);
    }

    if (activity.type === "run") {
      const { data: run } = activity;
      const updatedActivities = workoutActivities.map((a) => {
        if (getActivityId(a) === run.run_id) {
          return {
            parsed: `${run.distance} ${a.data.distance_type} run in ${run.time}`,
            type: "run",
            data: {
              ...a.data,
              ...run,
            },
          };
        } else {
          return a;
        }
      });
      setWorkoutActivities([...updatedActivities]);
    }

    if (activity.type === "row") {
      const { data: row } = activity;
      const updatedActivities = workoutActivities.map((a) => {
        if (getActivityId(a) === activity.data.row_id) {
          return {
            parsed: `${row.distance}m row in ${row.time}`,
            type: "row",
            data: {
              ...a.data,
              ...row,
            },
          };
        } else {
          return a;
        }
      });
      setWorkoutActivities([...updatedActivities]);
    }
  };

  const getActivityId = (activity) => {
    switch (activity.type) {
      case "exercise":
        return activity.data.exercise_id;
      case "run":
        return activity.data.run_id;
      case "row":
        return activity.data.row_id;
      default:
        console.log("not handled get activity id");
    }
  };

  const handleEditSelectChange = (activity) => {
    const id = getActivityId(activity);
    if (id === selectedIdForEdit) {
      setSelectedIdForEdit(null);
      setActivityForEdit(null);
    } else {
      setSelectedIdForEdit(id);
      setActivityForEdit(activity);
    }
  };

  return (
    <Workout
      workout={workout}
      workoutActivities={workoutActivities}
      workoutStats={workoutStats}
      bottomNavigationState={bottomNavigationState}
      selectedIdForEdit={selectedIdForEdit}
      activityForEdit={activityForEdit}
      onCheckBoxChange={handleCheckBoxChange}
      onEditActivity={handleEditActivity}
      onEditSelectChange={handleEditSelectChange}
      onCopyWorkout={handleCopyWorkout}
      onBottomNavChange={handleBottomNavigationChange}
      onDeleteWorkout={handleUserActionWithNoToken}
      onFinishWorkout={handleUserActionWithNoToken}
      onShareWorkout={handleUserActionWithNoToken}
      onCreateTemplate={handleUserActionWithNoToken}
      onAddExercise={handleUserActionWithNoToken}
      onAddRun={handleUserActionWithNoToken}
      onAddRow={handleUserActionWithNoToken}
      isPublic={true}
      loginRegisterOpen={loginRegisterOpen}
      handleOpenLoginRegister={handleOpenLoginRegister}
      handleCloseLoginRegister={handleCloseLoginRegister}
    />
  );
};

export default WorkoutPublicContainer
